<template>
  <div class="t-lk-how-work-with-leads">
    <h4 class="t-lk-how-work-with-leads__title">{{ $root.staticText.lk.leadsThird2 }}</h4>
    <div class="t-lk-how-work-with-leads__text">
      {{ $root.staticText.lk.leadsThirdText2 }}
    </div>
    <button class="t-lk-how-work-with-leads__btn" @click="$emit('modal:close')">{{ $root.staticText.lk.lkModalBtn }}</button>
  </div>
</template>

<script>
export default {
  name: "how-work-with-leads",
}
</script>

<style lang="sass">
@import "~@src/sass/params"

.t-modal__container
  overflow-y: hidden

.t-lk-how-work-with-leads
  display: flex
  flex-direction: column
  max-width: 417px

  &__title
    font-family: Roboto, sans-serif
    font-weight: 600
    font-size: 24px
    line-height: 155%
    color: $dark-blue-lk

  &__text
    font-family: Roboto, sans-serif
    margin-top: 16px
    line-height: 150%
    flex-grow: 1
    color: $dark-shades-black

  &__btn
    margin-top: 32px
    font-weight: 600
    color: #9FA2AC
    transition: color .2s

    &:hover
      color: $dark-shades-black
</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/how-work-with-leads.vue